import React from 'react';
// Components
import Navbar from '../../components/nav/Navbar';
import GalleryPageMainContainer from '../../components/gallery/GalleryPageMainContainer';
import GeneralHeader from '../../components/general/GeneralHeader';
import { HelmetItem } from '../../components/utils/HelmetItem';
// Consntants
import { CompanyName, LocationCity } from '../../utils/Constants';
// Data
import {
  galleryPageAdditionalMeta,
  galleryPageStructuredData,
} from '../../utils/data/MetaData';

const GalleryPage = React.memo(() => {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Gallery'
        desc={`Explore the gallery of ${CompanyName}, a professional dominatrix based in ${LocationCity}. Discover captivating images and scenes that showcase ${CompanyName}'s expertise in BDSM and intimate, tailored experiences. Get a glimpse into the unique world of domination through visual storytelling.`}
        keywords={`gallery, ${CompanyName}, dominatrix, BDSM, intimate experiences, domination, ${LocationCity}, professional services`}
        additionalMeta={galleryPageAdditionalMeta}
        structuredData={galleryPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour2 text-colour1 dark:bg-colour2 dark:text-colour1 font-poppins no__highlights'>
        <div className='grid'>
          {/* Navigation */}
          <Navbar />
          {/* Main page content */}
          <GalleryPageMainContainer />
        </div>
      </div>
    </>
  );
});

export default GalleryPage;
